import { ArrowRight, BarChart3, Globe2, Link2, Settings } from "lucide-react";


const actions = [
  { id: "create-link", label: "Create Link", detail: "Launch a tracked campaign", icon: Link2, path: "/redirector?tab=links&action=create-link", tone: "cyan" },
  { id: "manage-domains", label: "Manage Domains", detail: "Assign, release, or inspect", icon: Globe2, path: "/redirector?tab=domains", tone: "teal" },
  { id: "inspect-insights", label: "Inspect Insights", detail: "Traffic and threat telemetry", icon: BarChart3, path: "/insights", tone: "emerald" },
  { id: "open-settings", label: "Security Settings", detail: "Rules, destinations, and alerts", icon: Settings, path: "/settings?tab=security", tone: "amber" },
];

const toneClasses = {
  cyan: "border-cyan-500/25 text-cyan-300 group-hover:border-cyan-400/50 group-hover:bg-cyan-500/10",
  teal: "border-teal-500/25 text-teal-300 group-hover:border-teal-400/50 group-hover:bg-teal-500/10",
  emerald: "border-emerald-500/25 text-emerald-300 group-hover:border-emerald-400/50 group-hover:bg-emerald-500/10",
  amber: "border-amber-500/25 text-amber-300 group-hover:border-amber-400/50 group-hover:bg-amber-500/10",
};


export const DashboardQuickActions = ({ onNavigate }) => (
  <section data-testid="dashboard-quick-actions">
    <div className="mb-3 flex items-end justify-between"><div><p className="text-xs font-semibold uppercase text-cyan-400">Quick actions</p><h2 className="mt-1 font-orbitron text-base font-semibold uppercase text-slate-100">Operate WizardX</h2></div><p className="hidden text-xs text-slate-500 sm:block">Common workflows, one click away</p></div>
    <div className="grid grid-cols-2 gap-3 xl:grid-cols-4">
      {actions.map((action) => (
        <button key={action.id} type="button" onClick={() => onNavigate(action.path)} className={`group min-h-28 border bg-[#0c121d]/90 p-4 text-left rounded-md transition-[background-color,border-color] duration-150 ${toneClasses[action.tone]}`} data-testid={`quick-action-${action.id}`}>
          <div className="flex items-start justify-between"><action.icon className="h-5 w-5" /><ArrowRight className="h-4 w-4 text-slate-700 transition-[color,transform] duration-150 group-hover:translate-x-0.5 group-hover:text-slate-300" /></div>
          <p className="mt-4 text-sm font-semibold text-slate-100">{action.label}</p><p className="mt-1 text-xs leading-relaxed text-slate-500">{action.detail}</p>
        </button>
      ))}
    </div>
  </section>
);